
  <h1 mat-dialog-title>Single Family Track Settings</h1>

  <div [formGroup]="trackForm">
    <p>
      <mat-form-field>
        <mat-label>First Job Date</mat-label>
        <input matInput formControlName='firstjobdate' [matDatepicker]="firstjobdate">
        <mat-datepicker-toggle matSuffix [for]="firstjobdate"></mat-datepicker-toggle>
        <mat-datepicker #firstjobdate></mat-datepicker>
      </mat-form-field>
      <!-- Optional: Show error message if date is not selected -->
      <mat-error *ngIf="trackForm.get('firstjobdate').hasError('required')">
        First Job Date is required.
      </mat-error>
    </p>

    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Cancel</button>
      <button mat-button [disabled]="trackForm.invalid" (click)="onYesClick()">Done</button>
    </div>
  </div>
  